import { Comuna } from '../../entities/comunas';
import { Component, OnInit, Inject } from '@angular/core';
import { DireccionService } from '../../services/direccion.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DireccionServicioComponent } from '../direccion-servicio/direccion-servicio.component';
import { Municipio } from '../../entities/municipios';
import { Observable } from 'rxjs';
import { Barrio } from '../../entities/Barrio';
import swal from 'sweetalert2';

@Component({
  selector: 'app-edificio',
  templateUrl: './edificio.component.html',
  styleUrls: ['./edificio.component.scss']
})
export class EdificioComponent implements OnInit {
    public formData:FormGroup;
    public cities$: Observable<Array<Municipio>>;
    public comunas$: Observable<Array<Comuna>>;
    public barrios$: Observable<Array<Barrio>>;
    constructor(private _geo: DireccionService, private _modals:MatDialog, private _fb: FormBuilder, @Inject(MAT_DIALOG_DATA) private _data) { }
    ngOnInit() {
        console.log(this._data);
        this.formData = this._fb.group({
            nombre:[],
            tipo: [],
            ciudad:[this._data.city || ''],
            comuna:[],
            barrio:[this._data.barrio || ''],
            lat:[],
            lng:[]
        });
        this.cities$ = this._geo.getCiudades();
        if (this._data.city){
            this.comunas$ = this._geo.getComunasDeUnaCiudad(this._data.city);
        }
    }

    coordenadas(){
        let coords:MatDialogRef<DireccionServicioComponent> = this._modals.open(DireccionServicioComponent,{
            width:'70%',
            height:'90%'
        })
        coords.afterClosed()
            .subscribe((coords:{lat:number,lng:number})=>{
                this.formData.get("lat").setValue(coords.lat);
                this.formData.get("lng").setValue(coords.lng);
            })
    }

    loadComunas(){
        this.comunas$ = this._geo.getComunasDeUnaCiudad(this.formData.get("ciudad").value);

    }

    loadBarrios(){
        this.barrios$ = this._geo.getBarriosDeUnaComuna(this.formData.get("comuna").value);
    }

    save(){
        this._geo.newEdificio(this.formData.value)
                 .subscribe(end=>swal.fire({
                    title:'Exito',
                    type:'success',
                    text:'Se guardó con exito el edificio',
                    showConfirmButton: false,
                    timer:1000
                }));
    }
}
